class MiniCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');
    // MH perf fix 2026-09-14: keep a handle on the observer so renderContents()
    // can cancel it. Previously this fired an extra full-page fetch to
    // re-populate #mini-cart the FIRST time the drawer opened on a page --
    // including immediately after add-to-cart had already rendered fresh
    // content into the same element via the /cart/add.js response. That
    // redundant fetch was adding a real, measured multi-second delay before
    // the cart drawer appeared to respond on mobile. See STAGING theme notes.
    this.intersectionObserver = new IntersectionObserver(this.handleIntersection.bind(this));
    this.intersectionObserver.observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    // Skip the lazy-load fetch entirely if add-to-cart already rendered
    // fresh contents into this element moments ago -- nothing stale to fix.
    if (this.recentlyRenderedFromCart) return;

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(html => {
        document.getElementById('mini-cart').innerHTML =
          this.getSectionInnerHTML(html, '.shopify-section');

          document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
      })
      .catch(e => {
        console.error(e);
      });
  }

  open() {
    const detailsElement = this.drawer.querySelector('details');
    if (detailsElement.hasAttribute('open')) {
      return;
    }

    this.drawer.openMenuDrawer();
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    // MH perf fix 2026-09-14: this call means #mini-cart already has fresh,
    // correct HTML from the /cart/add.js response below -- cancel the
    // lazy-load observer so opening the drawer doesn't trigger a second,
    // redundant full-page fetch on top of it.
    this.recentlyRenderedFromCart = true;
    if (this.intersectionObserver) this.intersectionObserver.unobserve(this);
    this.getSectionsToRender().forEach((section => {
      if (document.getElementById(section.id)) {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    }));

    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('mini-cart', MiniCart);
